import React from 'react';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import * as appDataActions from '../../actions/appDataActions';
import * as keyboardConstants from '../../constants/keyboardConstants';
import * as appHelper from '../../helpers/appHelper';
import _ from 'lodash';


class TextResize extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            fontSize: this.props.fontSize,
            doUpdateFontSize: false,
            lang: this.props.lang,
            increase_font_size_label: appHelper.getLocaleString("increase_font_size_label"),
            decrease_font_size_label: appHelper.getLocaleString("decrease_font_size_label"),
            reset_font_size_label: appHelper.getLocaleString("reset_font_size_label"),
        };
        this.onIncreaseFont = this.onIncreaseFont.bind(this);
        this.onDecreaseFont = this.onDecreaseFont.bind(this);
        this.onResetFont = this.onResetFont.bind(this);
        this.canIncrease = this.canIncrease.bind(this);
        this.canDecrease = this.canDecrease.bind(this);
        this.changeFontSize = this.changeFontSize.bind(this);
        this.updateFontSize = this.updateFontSize.bind(this);
        this.onIncreaseFontKeyDown = this.onIncreaseFontKeyDown.bind(this);
        this.onDecreaseFontKeyDown = this.onDecreaseFontKeyDown.bind(this);
        this.onResetFontKeyDown = this.onResetFontKeyDown.bind(this);
    }

    componentDidMount() {

    }

    componentWillReceiveProps(nextProps) {
        if (this.state.fontSize !== nextProps.fontSize) {
            this.setState({fontSize: nextProps.fontSize});
        }

        if(this.state.lang !== nextProps.lang){
            this.setState({
                lang: nextProps.lang,
                increase_font_size_label: appHelper.getLocaleString("increase_font_size_label"),
                decrease_font_size_label: appHelper.getLocaleString("decrease_font_size_label"),
                reset_font_size_label: appHelper.getLocaleString("reset_font_size_label"),
            });
        }
    }

    componentDidUpdate() {
        if (this.state.doUpdateFontSize) {
            this.updateFontSize();
        }
    }

    updateFontSize() {
        this.setState({doUpdateFontSize: false});
        this.props.actions.updateFontSize(this.state.fontSize);
    }

    onIncreaseFont(event) {
        event.stopPropagation();
        this.changeFontSize(1);
    }

    onDecreaseFont(event) {
        event.stopPropagation();
        this.changeFontSize(-1);
    }

    onResetFont(event) {
        event.stopPropagation();
        this.setState({
            fontSize: Object.assign({}, this.state.fontSize, {
                currentFontSize: this.state.fontSize.resetFontSize,
            }),
            doUpdateFontSize: true
        });
    }

    onIncreaseFontKeyDown(event) {

        if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
            event.preventDefault();
            event.stopPropagation();
            this.changeFontSize(1);
        }
    }

    onDecreaseFontKeyDown(event) {

        if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
            event.preventDefault();
            event.stopPropagation();
            this.changeFontSize(-1);
        }
    }

    onResetFontKeyDown(event) {

        if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
            event.preventDefault();
            event.stopPropagation();
            this.setState({
                fontSize: Object.assign({}, this.state.fontSize, {
                    currentFontSize: this.state.fontSize.resetFontSize,
                }),
                doUpdateFontSize: true
            });
        }
    }

    changeFontSize(sizeDifference) {
        let currentFontSize = parseInt(this.state.fontSize.currentFontSize) + parseInt(sizeDifference * 5);
        if (currentFontSize > this.state.fontSize.maxFontSize) {
            currentFontSize = this.state.fontSize.maxFontSize;
        } else if (currentFontSize < this.state.fontSize.minFontSize) {
            currentFontSize = this.state.fontSize.minFontSize;
        }
        this.setState({
            fontSize: Object.assign({}, this.state.fontSize, {
                currentFontSize: currentFontSize,
            }),
            doUpdateFontSize: true
        });
    }

    canIncrease() {
        return this.state.fontSize.currentFontSize === this.state.fontSize.maxFontSize;


    }

    canDecrease() {
        return this.state.fontSize.currentFontSize === this.state.fontSize.minFontSize;
    }

    render() {
        return (
            <ul className="text-resize-list">
                <li className="text-resize-item">
                    <button className="resize-btn increase-font-btn" onClick={this.onIncreaseFont} onKeyDown={this.onIncreaseFontKeyDown}
                            disabled={this.canIncrease()}><span className="hidden-el">{this.state.increase_font_size_label}</span></button>
                </li>
                <li className="text-resize-item">
                    <button className="resize-btn decrease-font-btn" onClick={this.onDecreaseFont} onKeyDown={this.onDecreaseFontKeyDown}
                            disabled={this.canDecrease()}><span className="hidden-el">{this.state.decrease_font_size_label}</span></button>
                </li>
                <li className="text-resize-item">
                    <button className="resize-btn reset-font-btn" onClick={this.onResetFont} onKeyDown={this.onResetFontKeyDown}><span className="hidden-el">{this.state.reset_font_size_label}</span>
                    </button>
                </li>
            </ul>
        );
    }

}

TextResize.propTypes = {
    lang: PropTypes.string.isRequired,
    fontSize: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
};

function mapStateToProps(state, ownProps) {

    let lang = state.userData.lang;
    return {
        lang:lang,
        fontSize: state.fontSize
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, appDataActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(TextResize);


/** WEBPACK FOOTER **
 ** ./src/components/accessibility/TextResize.js
 **/